import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosSettings } from "../../axios/axios";
import { WeatherState, WeatherParams, WeatherApiResponse } from "./WeatherType";
import { RootState } from "../../redux/store";
import { GetTime } from "../../utils/timeget";

//情報取得API連携
export const fetchAsyncWeather: any = createAsyncThunk<
  WeatherApiResponse & { page: number },
  WeatherParams
>("Weather/get", async (page) => {
  const response = await axiosSettings.get(
    `/api-admin/weather/per-day?page=${page}`
  );
  return { ...response.data, page };
});

const initialState: WeatherState = {
  initialWeather: null,
  otherWeather: null,
  selectedDate: null,
  loading: false,
  error: "",
};

const WeatherSlice = createSlice({
  name: "Weather",
  initialState: initialState,
  reducers: {
    handleDate: (state, action) => {
      state.selectedDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAsyncWeather.fulfilled, (state, action) => {
      //トークン認証&通信成功、データを受け取る
      const page = action.payload.page;
      const data = action.payload.data.result;
      //1ページ目だけ保持、その他は都度更新
      if (page === 1) {
        state.initialWeather = data;
        state.error = "";
      } else {
        state.otherWeather = data;
      }
      state.loading = false;
    });
    builder.addCase(fetchAsyncWeather.pending, (state, action) => {
      state.loading = true;
    });
    // builder.addCase(fetchAsyncWeather.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.payload.data;
    // });
  },
});

export const initialWeatherInfo = (state: RootState) =>
  state.Weather.initialWeather;
export const otherWeatherInfo = (state: RootState) =>
  state.Weather.otherWeather;
export const selectedDate = (state: RootState) => state.Weather.selectedDate;
export const weatherError = (state: RootState) => state.Weather.error;
export const weatherLoading = (state: RootState) => state.Weather.loading;
export const { handleDate } = WeatherSlice.actions;
export default WeatherSlice.reducer;
